












































































































































import Company from '../apiClient/Company'
import User from '../apiClient/User'

export default {
  name: 'UpdateLogo',
  data() {
    return {
      error: '' as string,
      newLogo: '' as string,
      errorModal: '' as string,
      loading: false as boolean,
      showModal: false as boolean,
      previewNewLogo: '' as string,
      confirmPassword: '' as string,
      disableSaveBtn: true as boolean,
      actualLogo: this.$store.state.companyLogo as string
    }
  },
  methods: {
    selectFile(file: File): void | undefined {
      this.loading = true
      if (!file) {
        this.error = ''
        this.newLogo = ''
        this.disableSaveBtn = true
        this.loading = false
        return
      }
      if (file) {
        if (file.size > 1000000) {
          this.error = this.$t('message.updateLogo.errors.maxSizeExceeded') as string
          this.disableSaveBtn = true
          this.loading = false
          return
        }
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          this.error = this.$t('message.updateLogo.errors.wrongType') as string
          this.disableSaveBtn = true
          this.loading = false
          return
        }
        this.previewNewLogo = URL.createObjectURL(file)
        this.newLogo = file
        this.disableSaveBtn = false
        this.loading = false
      }
    },
    cancel(): void {
      this.error = ''
      this.newLogo = ''
      this.$router.push('/MainBusinessPage')
    },
    save(): void {
      this.showModal = true
    },
    async confirm(): Promise<void> {
      if (this.confirmPassword.length < 3) return
      if (!this.confirmPassword) return
      const user = new User()
      const valid = await user
        .validPass(this.confirmPassword)
        .then((res) => res)
        .catch((err) => err)
      if (valid.status === 200) {
        const company = new Company()
        await company
          .updateLogo({ logo: this.newLogo })
          .then(() => {
            this.$store.dispatch(
              'setCompanyLogo',
              this.$store.state.user.empresa.id
            )
            this.$router.push('/MainBusinessPage')
          })
          .catch((error) => {
            if (error.response.status === 400) {
              const { codes } = error.response.data
              let msg = ''
              if (codes[0].code === 'COMPANY_LOGO_S3_EXCEPTION')
                msg = this.$t('message.updateLogo.errors.exception')
              if (codes[0].code === 'COMPANY_LOGO_FS_EXCEPTION')
                msg = this.$t('message.updateLogo.errors.exception')
              if (codes[0].code === 'SYSTEM_API_WRONG_MIME_TYPE')
                msg = this.$t('message.updateLogo.errors.wrongType')
              if (codes[0].code === 'SYSTEM_API_PARAMETER_NOT_EXPECTED')
                msg = this.$t('message.updateLogo.errors.parameterExpected')
              if (codes[0].code === 'SYSTEM_API_MAX_FILE_SIZE_EXCEEDED')
                msg = this.$t('message.updateLogo.errors.maxSizeExceeded')
              this.errorModal = `Error 400: ${msg}`
            }
            if (error.response.status === 403) {
              const { data } = error.response
              this.errorModal = `Error ${data.code}: ${this.$t(
                'message.updateLogo.errors.unauthorized'
              )}`
            }
          })
      } else {
        this.errorModal = this.$t('message.passwordExpired.message_error.error_00034') as string
      }
    }
  }
}
